import { render, staticRenderFns } from "./ServicejobUpdate.vue?vue&type=template&id=c03f4a58&scoped=true"
import script from "./ServicejobUpdate.vue?vue&type=script&lang=js"
export * from "./ServicejobUpdate.vue?vue&type=script&lang=js"
import style0 from "./ServicejobUpdate.vue?vue&type=style&index=0&id=c03f4a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03f4a58",
  null
  
)

export default component.exports